import React, { useState, useEffect } from 'react';
import { Search, Edit, Plus, Save, X, Users, ChevronRight, ChevronDown, Shield, UserCheck, UserX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import usePermissions from './usePermissions';

// ✅ الصلاحيات مرتبة في مجموعات منطقية — كل شيء له علاقة ببعضه جنب بعض
const PERMISSION_GROUPS = [
  {
    id: 'data',
    label: 'البيانات',
    color: 'blue',
    icon: '🗂️',
    sections: [
      {
        key: 'البيانات',
        label: 'البيانات الأساسية',
        items: ['الشركات', 'المناديب', 'المهن', 'الاختبارات', 'قوائم العمل']
      },
      {
        key: 'إدارة الاختبارات',
        label: 'إدارة الاختبارات - الصلاحيات',
        items: [
          'عرض الاختبارات', 'عرض إحصائيات الكشف', 'البحث والفلترة', 'البحث العام', 'الترتيب', 'التحديد المتعدد', 'تحديث البيانات',
          'إنشاء كشف', 'إنشاء نسخة فارغة من كشف', 'تعديل الكشوف', 'حذف الكشوف',
          'إضافة شخص', 'تعديل الأشخاص', 'حذف الأشخاص',
          'تحميل نموذج الاستيراد', 'استيراد',
          'تصدير Excel', 'طباعة', 'تصدير كصورة', 'تصدير صور المناديب ZIP', 'تصدير جهات الاتصال',
          'التكرار الذكي', 'عرض سجل الحالات', 'تغيير حالة الشخص', 'إدارة الحالات', 'إدارة الحقول', 'فتح الجواز المرتبط',
          'فحص المسجلين بالهاتف', 'تسجيل في الجوازات', 'تعليم كمسجل بالجوازات', 'ضبط نموذج التسجيل في الجوازات', 'تجاوز تكرار الهاتف',
          'إضافة لقائمة عمل'
        ]
      },
      {
        key: 'إدارة قوائم العمل',
        label: 'قوائم العمل - الصلاحيات',
        items: [
          'عرض قوائم العمل', 'فتح قائمة', 'إنشاء قائمة', 'تعديل القوائم', 'حذف القوائم', 'إغلاق القوائم',
          'البحث والفلترة', 'إضافة أشخاص', 'تحديث حالة الشخص',
          'عرض الملاحظات', 'إضافة ملاحظة', 'حذف ملاحظة', 'إزالة أشخاص',
          'طباعة', 'تصدير Excel'
        ]
      }
    ]
  },
  {
    id: 'passports',
    label: 'الجوازات',
    color: 'emerald',
    icon: '📋',
    sections: [
      {
        key: 'الجوازات',
        label: 'الصفحات',
        items: ['الجوازات', 'الاختيار والتجهيزات', 'الكشوفات', 'التكرار الذكي']
      },
      {
        key: 'إدارة الجوازات',
        label: 'إدارة الجوازات - الصلاحيات',
        items: [
          'عرض الجوازات', 'إضافة جواز جديد', 'تعديل الجوازات', 'حذف الجوازات',
          'الإدخال السريع', 'المعالجة المجمعة', 'ضبط النموذج', 'طريقة حقل المهنة بالجواز', 'إنشاء سفرة جديدة',
          'إدارة الملاحظات', 'تسليم الجوازات', 'تراجع عن التسليم', 'تغيير المندوب',
          'التكرار الذكي', 'المسح الذكي', 'إعدادات التحذيرات والإشعارات', 'إدارة قائمة المنع', 'ضبط الباركود وطرق الطباعة',
          'طباعة الطرق المحفوظة', 'عرض التاريخ', 'أمان التسليم',
          'التحكم في الحالات', 'فك بيانات', 'عرض فقط', 'عرض زر سجل الجوازات', 'سجل الإنشاء والتعديل والتسليم',
          'رقم الطلب', 'تاريخ البصمة', 'تاريخ التأشير', 'تاريخ السفر',
          'تاريخ عمل النت', 'تاريخ الكشف الطبي', 'حالة الكشف الطبي',
          'تاريخ التأمين الطبي', 'رقم الحدود', 'المخالفة / ملاحظتها',
          'تعديل يدوي - حالة الكشف الطبي', 'تعديل يدوي - تاريخ الكشف الطبي',
          'تعديل يدوي - تاريخ عمل النت', 'تعديل يدوي - رقم الطلب',
          'تعديل يدوي - تاريخ البصمة', 'تعديل يدوي - تاريخ التأمين الطبي',
          'تعديل يدوي - تاريخ التأشير', 'تعديل يدوي - تاريخ السفر',
          'تعديل يدوي - رقم الحدود', 'تعديل يدوي - المخالفة / ملاحظتها',
          'تاريخ انتهاء الرخصة', 'نوع الرخصة'
        ]
      },
      {
        key: 'الشات الداخلي',
        label: 'الشات الداخلي - الصلاحيات',
        items: ['تسجيل الجواز من الشات الداخلي']
      },
      {
        key: 'ضبط الباركود وطرق الطباعة - نافذة الضبط',
        label: 'ضبط الباركود وطرق الطباعة - مناطق النافذة',
        items: [
          'نافذة الباركود - عرض كل مناطق النافذة',
          'نافذة الباركود - المعاينة والسحب',
          'نافذة الباركود - اختبار وطباعة',
          'نافذة الباركود - حفظ واستعادة الإعدادات',
          'نافذة الباركود - طرق الطباعة المحفوظة',
          'نافذة الباركود - الطباعة التلقائية',
          'نافذة الباركود - إعدادات الليبل والطابعة',
          'نافذة الباركود - عنصر الاسم',
          'نافذة الباركود - عنصر ID',
          'نافذة الباركود - عنصر الباركود أو QR',
          'نافذة الباركود - محتوى الرمز',
          'نافذة الباركود - دليل التشغيل',
          'نافذة الباركود - تنبيه Masar Print Agent'
        ]
      },
      {
        key: 'الاختيار والتجهيز - الرصيد',
        label: 'الاختيار والتجهيز - الرصيد',
        items: [
          'عرض زر فحص رصيد العميل', 'عرض الرصيد الحالي',
          'عرض إجمالي الإيداعات', 'عرض إجمالي السحوبات',
          'عرض زر كشف الأرصدة الشامل', 'عرض إجمالي الأرصدة في الكشف الشامل',
          'عرض الرصيد في الكشف الشامل'
        ]
      },
      {
        key: 'مركز التقارير - الجوازات - الفلاتر',
        label: 'مركز التقارير - الفلاتر',
        items: [
          'إظهار حالة النشاط', 'إظهار مربع الفلاتر المتقدمة',
          'إظهار القوائم المحفوظة', 'إظهار استثناء عناصر القوائم المختارة', 'إظهار عرض البيانات المؤرشفة للقوائم',
          'إظهار حالة التسليم', 'إظهار حالة المعالجة', 'إظهار مرحلة المعالجة',
          'إظهار فلتر المناديب', 'إظهار فلتر الشركات', 'إظهار فلتر المهن بالجواز', 'إظهار فلتر مهن السفر',
          'إظهار فلتر مدة السفر', 'إظهار فلتر حالة الجواز', 'إظهار فلتر الشركات السابقة',
          'إظهار فلتر التواريخ', 'إظهار فلتر تاريخ الإضافة', 'إظهار فلتر تاريخ الكشف الطبي',
          'إظهار فلتر تاريخ عمل النت', 'إظهار فلتر تاريخ البصمة', 'إظهار فلتر تاريخ التأمين الطبي',
          'إظهار فلتر تاريخ دخول القنصلية', 'إظهار فلتر تاريخ التأشير', 'إظهار فلتر تاريخ السفر',
          'إظهار فلاتر الملاحظات', 'إظهار فلتر جميع الملاحظات', 'إظهار فلتر ملاحظة 1',
          'إظهار فلتر ملاحظة 2', 'إظهار فلتر ملاحظة 3', 'إظهار فلتر ملاحظة 4',
          'إظهار فلتر المحافظات'
        ]
      },
      {
        key: 'مركز التقارير - الجوازات - الأزرار',
        label: 'مركز التقارير - الأزرار',
        items: [
          'زر معاينة تفاعلية', 'زر PDF متقدم', 'زر Excel متقدم',
          'زر طباعة احترافية', 'زر طباعة Agent', 'زر طباعة باركود جماعية', 'زر تصدير جهات الاتصال', 'زر تصدير كصورة', 'زر تصدير صور المناديب ZIP', 'زر التكرار الذكي',
          'زر تصدير الصور ZIP', 'زر ضبط الإعدادات', 'زر تخصيص الأعمدة'
        ]
      }
    ]
  },
  {
    id: 'visas',
    label: 'التأشيرات',
    color: 'indigo',
    icon: '🛂',
    sections: [
      {
        key: 'التأشيرات',
        label: 'الصفحات',
        items: ['المتابعة الدورية']
      },
      {
        key: 'المتابعة الدورية',
        label: 'المتابعة الدورية - الصلاحيات',
        items: [
          'عرض زر القائمة الموحدة', 'عرض شريط القائمة الموحدة', 'عرض الإحصائيات',
          'عرض زر سجل المتابعة الدورية',
          'إدخال رقم الطلب', 'تعديل رقم الهاتف', 'تعديل الملاحظات',
       'إدخال تاريخ الكشف الطبي', 'إدخال تاريخ البصمة', 'إدخال تاريخ التأمين الطبي', 'إدخال تسليم الأوراق',
          'إدخال دخول القنصلية', 'إدخال التأشيرة', 'إدخال السفر', 'إدخال رقم الحدود',
          'الحذف', 'التحديث الجماعي', 'إرسال للمناديب', 'إخفاء وإظهار القوائم',
          'عرض عمود رقم الطلب', 'عرض عمود الهاتف', 'عرض عمود تاريخ النت',
       'عرض عمود الكشف الطبي', 'عرض عمود البصمة', 'عرض عمود التأمين الطبي', 'عرض عمود تسليم الأوراق',
          'عرض عمود دخول القنصلية', 'عرض عمود التأشيرة', 'عرض عمود السفر',
          'عرض عمود رقم الحدود', 'عرض عمود الملاحظات'
        ]
      },
      {
        key: 'باركود المتابعة الدورية',
        label: 'باركود المتابعة الدورية - رقم الطلب',
        items: [
          'طباعة تنفيذ باركود رقم الطلب',
          'عرض زر ضبط الباركود',
          'حفظ باسم وجعله النشط',
          'حذف إعداد باركود محفوظ',
          'حفظ إعداد الباركود لكل المستخدمين',
          'طباعة باركود المحدد'
        ]
      },
      {
        key: 'إحصائيات المتابعة الدورية',
        label: 'إحصائيات المتابعة الدورية',
        items: [
          'عرض العدد المطلوب', 'عرض إجمالي الحضور', 'عرض العدد المتبقي',
          'عرض اللائق', 'عرض البصمة', 'عرض التأشيرة', 'عرض سافروا'
        ]
      }
    ]
  },
  {
    id: 'accounts',
    label: 'الحسابات',
    color: 'purple',
    icon: '💰',
    sections: [
      {
        key: 'الحسابات',
        label: 'الصفحات',
        items: ['الخزينة الشاملة', 'إيرادات ومصروفات الشركة', 'حسابات العملاء', 'حسابات المناديب', 'حسابات الموظفين', 'التقارير']
      },
      {
        key: 'الخزينة - الصلاحيات',
        label: 'الخزينة - الصلاحيات',
        items: ['إضافة حساب جديد', 'إضافة تصنيف جديد', 'حذف الحساب', 'حذف المعاملة']
      },
      {
        key: 'إيرادات ومصروفات - الصلاحيات',
        label: 'إيرادات ومصروفات - الصلاحيات',
        items: ['إضافة معاملة', 'إدارة التصنيفات', 'معاينة المعاملة', 'تعديل المعاملة', 'حذف المعاملة']
      },
      {
        key: 'حسابات العملاء - الصلاحيات',
        label: 'حسابات العملاء - الصلاحيات',
        items: [
          'إدارة المبالغ المطلوبة', 'البحث عن عميل', 'البحث عن معاملات',
          'معاينة الحساب', 'تعديل المعاملة', 'حذف المعاملة',
          'إضافة إيداع', 'إضافة سحب', 'تعديل المبلغ المطلوب'
        ]
      },
      {
        key: 'حسابات المناديب - الصلاحيات',
        label: 'حسابات المناديب - الصلاحيات',
        items: ['إعدادات العمولة', 'دفع عمولة', 'تصحيح حالة العمولة', 'إدارة المديونيات', 'حذف معاملة']
      },
      {
        key: 'حسابات الموظفين - الصلاحيات',
        label: 'حسابات الموظفين - الصلاحيات',
        items: [
          'إضافة موظف', 'تعديل موظف', 'حذف موظف', 'دفع راتب', 'دفع الراتب المتأخر',
          'إضافة سلفة', 'تعديل سلفة', 'بونص وخصم', 'تعديل معاملة', 'حذف معاملة'
        ]
      }
    ]
  },
  {
    id: 'system',
    label: 'النظام',
    color: 'rose',
    icon: '⚙️',
    sections: [
      {
        key: 'المستخدمين',
        label: 'إدارة المستخدمين',
        items: ['المستخدمين']
      },
      {
        key: 'إدارة قاعدة البيانات',
        label: 'قاعدة البيانات',
        items: ['إدارة البيانات', 'النسخ الاحتياطي وإدارة قاعدة البيانات']
      },
      {
        key: 'إعدادات',
        label: 'الإعدادات',
        items: ['مفاتيح الـ OCR']
      }
    ]
  }
];

const GROUP_COLORS = {
  blue:    { tab: 'bg-blue-600 text-white',    tabOff: 'bg-blue-50 text-blue-700 hover:bg-blue-100',    header: 'bg-blue-50 border-blue-200 text-blue-800',    check: 'accent-blue-600',    badge: 'bg-blue-100 text-blue-700',    activeBadge: 'bg-white/25 text-white' },
  emerald: { tab: 'bg-emerald-600 text-white', tabOff: 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100', header: 'bg-emerald-50 border-emerald-200 text-emerald-800', check: 'accent-emerald-600', badge: 'bg-emerald-100 text-emerald-700', activeBadge: 'bg-white/25 text-white' },
  indigo:  { tab: 'bg-indigo-600 text-white',  tabOff: 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100',  header: 'bg-indigo-50 border-indigo-200 text-indigo-800',  check: 'accent-indigo-600',  badge: 'bg-indigo-100 text-indigo-700',  activeBadge: 'bg-white/25 text-white' },
  purple:  { tab: 'bg-purple-600 text-white',  tabOff: 'bg-purple-50 text-purple-700 hover:bg-purple-100',  header: 'bg-purple-50 border-purple-200 text-purple-800',  check: 'accent-purple-600',  badge: 'bg-purple-100 text-purple-700',  activeBadge: 'bg-white/25 text-white' },
  rose:    { tab: 'bg-rose-600 text-white',    tabOff: 'bg-rose-50 text-rose-700 hover:bg-rose-100',    header: 'bg-rose-50 border-rose-200 text-rose-800',    check: 'accent-rose-600',    badge: 'bg-rose-100 text-rose-700',    activeBadge: 'bg-white/25 text-white' },
};

const WARNING_PERMISSIONS = {
  'طريقة حقل المهنة بالجواز': 'تحذير: تفعيل هذه الصلاحية يسمح للمستخدم بتغيير طريقة مهنة الجواز لكل المستخدمين والأجهزة.',
  'حفظ باسم وجعله النشط': 'تحذير: هذه الصلاحية تسمح بحفظ طريقة باركود وجعلها الإعداد النشط الذي يستخدمه زر التنفيذ على الشبكة.',
  'حذف إعداد باركود محفوظ': 'تحذير: هذه الصلاحية تسمح بحذف طرق باركود محفوظة من قاعدة البيانات.',
  'حفظ إعداد الباركود لكل المستخدمين': 'تحذير: هذه الصلاحية تسمح بتغيير إعداد طباعة الباركود المستخدم لكل المستخدمين والأجهزة.',
  'طباعة باركود المحدد': 'تنبيه: هذه الصلاحية تسمح بطباعة باركود لأكثر من عميل محدد من وضع التحديث الجماعي.',
  'زر طباعة Agent': 'تنبيه: هذه الصلاحية تسمح للمستخدم بإرسال التقارير الاحترافية للطباعة على أجهزة Masar Print Agent المتصلة بالشبكة.',
  'زر طباعة باركود جماعية': 'تنبيه: هذه الصلاحية تسمح للمستخدم بطباعة باركود جميع نتائج البحث الظاهرة في مركز التقارير باستخدام طرق الطباعة المحفوظة.',
  'زر تصدير جهات الاتصال': 'تنبيه: هذه الصلاحية تسمح للمستخدم بتصدير أرقام وبيانات تعريف جهات الاتصال لكل النتائج المعروضة في مركز التقارير.'
};

// ── بطاقة مستخدم ─────────────────────────────────────────────────────────────
const UserCard = ({ user, onEdit, onDeactivate, onActivate, permCount }) => {
  const isActive = user.IsActive === undefined || user.IsActive === null ? true : Boolean(user.IsActive);

  return (
    <div className={`bg-white border rounded-2xl p-4 hover:shadow-md transition-shadow md:flex md:items-center md:gap-4 max-md:shadow-sm max-md:overflow-hidden ${isActive ? 'border-gray-200 max-md:border-gray-100' : 'border-red-100 bg-red-50/30 opacity-80'}`}>
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className={`w-12 h-12 md:w-11 md:h-11 rounded-2xl md:rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0 shadow-sm ${isActive ? 'bg-gradient-to-br from-blue-500 to-indigo-600' : 'bg-gradient-to-br from-gray-400 to-gray-600'}`}>
          {(user.FullName || user.Username || '?')[0]}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <p className="font-bold md:font-semibold text-gray-900 truncate text-base md:text-sm">{user.FullName || '—'}</p>
            <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${isActive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
              {isActive ? 'نشط' : 'موقوف'}
            </span>
          </div>
          <p className="text-sm text-gray-500 truncate mt-0.5">{user.Username}</p>
          <p className="text-xs text-gray-400 truncate mt-0.5">{user.Email}</p>
        </div>
      </div>

      <div className="mt-3 md:mt-0 flex items-center justify-between md:justify-end md:gap-3">
        <span className="bg-blue-50 text-blue-700 text-xs font-bold px-3 py-1.5 rounded-full whitespace-nowrap flex-shrink-0">
          🛡️ {permCount} صلاحية
        </span>
        <div className="hidden md:flex gap-1 flex-shrink-0">
          <button onClick={() => onEdit(user)} className="p-2 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors" title="تعديل">
            <Edit size={17} />
          </button>
          {isActive ? (
            <button onClick={() => onDeactivate(user.UserId)} className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors" title="إيقاف المستخدم">
              <UserX size={17} />
            </button>
          ) : (
            <button onClick={() => onActivate(user.UserId)} className="p-2 rounded-lg text-green-600 hover:bg-green-50 transition-colors" title="تفعيل المستخدم">
              <UserCheck size={17} />
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 mt-3 md:hidden">
        <button onClick={() => onEdit(user)} className="flex items-center justify-center gap-2 rounded-xl bg-blue-50 text-blue-700 py-2.5 text-sm font-semibold active:scale-[0.98] transition">
          <Edit size={16} />
          تعديل
        </button>
        {isActive ? (
          <button onClick={() => onDeactivate(user.UserId)} className="flex items-center justify-center gap-2 rounded-xl bg-red-50 text-red-600 py-2.5 text-sm font-semibold active:scale-[0.98] transition">
            <UserX size={16} />
            إيقاف
          </button>
        ) : (
          <button onClick={() => onActivate(user.UserId)} className="flex items-center justify-center gap-2 rounded-xl bg-green-50 text-green-700 py-2.5 text-sm font-semibold active:scale-[0.98] transition">
            <UserCheck size={16} />
            تفعيل
          </button>
        )}
      </div>
    </div>
  );
};

// ── قسم صلاحيات قابل للطي ────────────────────────────────────────────────────
const PermissionSection = ({ sectionKey, label, items, permissions, color, onChange, onSelectAll }) => {
  const [open, setOpen] = useState(true);
  const c = GROUP_COLORS[color];
  const allSelected = items.every(item => permissions[sectionKey]?.[item]);
  const selectedCount = items.filter(item => permissions[sectionKey]?.[item]).length;

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden mb-3 max-md:shadow-sm max-md:bg-white">
      <div
        className={`flex items-center justify-between gap-2 px-3 md:px-4 py-2.5 md:py-3 cursor-pointer select-none ${c.header} border-b`}
        onClick={() => setOpen(o => !o)}
      >
        <div className="flex items-center gap-2 min-w-0 flex-1">
          {open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}
          <span className="font-semibold text-sm max-md:text-[13px] max-md:leading-5 max-md:break-words">{label}</span>
          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${c.badge}`}>
            {selectedCount} / {items.length}
          </span>
        </div>
        <button
          type="button"
          onClick={e => { e.stopPropagation(); onSelectAll(sectionKey, items); }}
          className={`text-xs px-2 md:px-3 py-1 rounded-full font-medium transition-colors border whitespace-nowrap ${
            allSelected ? 'bg-red-50 text-red-600 border-red-200 hover:bg-red-100' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
          }`}
        >
          {allSelected ? 'إلغاء الكل' : 'تحديد الكل'}
        </button>
      </div>
      {open && (
        <div className="p-2.5 md:p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5 bg-white">
          {items.map(item => {
            const checked = !!permissions[sectionKey]?.[item];
            const warningText = WARNING_PERMISSIONS[item];
            return (
              <label
                key={item}
                title={warningText || item}
                className={`flex items-start gap-2 cursor-pointer group rounded-xl px-3 py-2.5 md:p-2 min-h-[42px] max-md:w-full max-md:min-w-0 border transition-colors ${
                  warningText
                    ? checked
                      ? 'bg-red-50 border-red-200 ring-1 ring-red-100'
                      : 'bg-amber-50 border-amber-200 hover:bg-amber-100'
                    : 'bg-gray-50 md:bg-transparent border-transparent hover:bg-gray-50'
                }`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => onChange(sectionKey, item)}
                  className={`w-4 h-4 mt-0.5 rounded cursor-pointer flex-shrink-0 ${warningText ? 'accent-red-600' : c.check}`}
                />
                <span className={`text-sm max-md:text-[13px] max-md:leading-5 max-md:break-words transition-colors ${
                  warningText
                    ? checked ? 'text-red-800 font-black' : 'text-amber-800 font-bold'
                    : checked ? 'text-gray-900 font-medium' : 'text-gray-500 group-hover:text-gray-700'
                }`}>
                  {warningText && <span className="ml-1">⚠️</span>}
                  {item}
                  {warningText && <span className="block text-[11px] font-medium mt-1 leading-5 text-amber-700">{warningText}</span>}
                </span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
const UserManagement = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState(PERMISSION_GROUPS[0].id);
  const [accountPanelOpen, setAccountPanelOpen] = useState(true);
  const [formData, setFormData] = useState({ username: '', password: '', fullName: '', email: '', permissions: {} });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => { fetchUsers(); }, []);

  const fetchUsers = async () => {
    try {
      const res = await fetch(`${config.API_BASE_URL}/api/users`);
      if (!res.ok) throw new Error('فشل جلب المستخدمين');
      setUsers(await res.json());
    } catch (err) { console.error('خطأ في جلب المستخدمين:', err); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = editingId
        ? await fetch(`${config.API_BASE_URL}/api/users/${editingId}`, {
            method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData)
          })
        : await fetch(`${config.API_BASE_URL}/api/users`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData)
          });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'خطأ في حفظ المستخدم');

      fetchUsers();
      resetForm();
    } catch (err) {
      console.error('خطأ في حفظ المستخدم:', err);
      alert(err.message || 'خطأ في حفظ المستخدم');
    }
  };

  const handleEdit = (user) => {
    let parsedPermissions = {};
    try {
      parsedPermissions = JSON.parse(user.Permissions || '{}');
    } catch {
      parsedPermissions = {};
    }

    setFormData({ username: user.Username, password: '', fullName: user.FullName, email: user.Email, permissions: parsedPermissions });
    setEditingId(user.UserId);
    setActiveTab(PERMISSION_GROUPS[0].id);
    setAccountPanelOpen(true);
    setShowForm(true);
  };

  const handleDeactivate = async (userId) => {
    if (window.confirm('هل تريد إيقاف هذا المستخدم؟\nلن يتم حذف الجوازات أو السجلات المرتبطة به.')) {
      try {
        const res = await fetch(`${config.API_BASE_URL}/api/users/${userId}`, { method: 'DELETE' });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || 'خطأ في إيقاف المستخدم');
        fetchUsers();
      } catch (err) {
        console.error('خطأ في إيقاف المستخدم:', err);
        alert(err.message || 'خطأ في إيقاف المستخدم');
      }
    }
  };

  const handleActivate = async (userId) => {
    if (window.confirm('هل تريد تفعيل هذا المستخدم مرة أخرى؟')) {
      try {
        const res = await fetch(`${config.API_BASE_URL}/api/users/${userId}/activate`, { method: 'PUT' });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || 'خطأ في تفعيل المستخدم');
        fetchUsers();
      } catch (err) {
        console.error('خطأ في تفعيل المستخدم:', err);
        alert(err.message || 'خطأ في تفعيل المستخدم');
      }
    }
  };

  const resetForm = () => {
    setFormData({ username: '', password: '', fullName: '', email: '', permissions: {} });
    setEditingId(null);
    setAccountPanelOpen(true);
    setShowForm(false);
  };

  const handlePermissionChange = (section, item) => {
    setFormData(prev => ({
      ...prev,
      permissions: { ...prev.permissions, [section]: { ...(prev.permissions[section] || {}), [item]: !(prev.permissions[section]?.[item]) } }
    }));
  };

  const handleSectionSelectAll = (section, items) => {
    const allSelected = items.every(item => formData.permissions[section]?.[item]);
    setFormData(prev => ({
      ...prev,
      permissions: { ...prev.permissions, [section]: items.reduce((acc, item) => ({ ...acc, [item]: !allSelected }), {}) }
    }));
  };

  const getPermissionCount = (permissionsStr) => {
    try {
      const p = JSON.parse(permissionsStr || '{}');
      return Object.values(p).reduce((t, s) => t + Object.values(s).filter(Boolean).length, 0);
    } catch { return 0; }
  };

  const getGroupSelectedCount = (group) =>
    group.sections.reduce((total, sec) => total + sec.items.filter(item => formData.permissions[sec.key]?.[item]).length, 0);

  const filteredUsers = users.filter(u =>
    u.Username.toLowerCase().includes(search.toLowerCase()) ||
    u.FullName?.toLowerCase().includes(search.toLowerCase()) ||
    u.Email?.toLowerCase().includes(search.toLowerCase())
  );

  const activeUsersCount = users.filter(u => u.IsActive === undefined || u.IsActive === null ? true : Boolean(u.IsActive)).length;

  return (
    <div className="min-h-screen bg-gray-50 max-md:overflow-x-hidden" dir="rtl">

      {/* ── الهيدر ─────────────────────────────────────────────────────────── */}
      <div className="bg-white border-b border-gray-200 px-4 md:px-6 py-3 md:py-4 sticky top-0 z-10">
        <div className="max-w-6xl mx-auto flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center flex-shrink-0">
              <Users size={20} className="text-white" />
            </div>
            <div>
              <h1 className="text-lg md:text-xl font-bold text-gray-900">إدارة المستخدمين</h1>
              <p className="text-xs md:text-sm text-gray-400">{activeUsersCount} نشط / {users.length} مستخدم</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 bg-gray-100 hover:bg-gray-200 px-3 md:px-4 py-2 rounded-lg transition-colors flex-shrink-0"
          >
            <ChevronRight size={16} />
            الرئيسية
          </button>
        </div>
      </div>

      {/* ── شريط البحث + إضافة ─────────────────────────────────────────────── */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-4 md:py-5">
        <div className="flex flex-col md:flex-row md:items-center gap-3">
          <div className="relative w-full md:flex-1 md:max-w-sm">
            <Search size={15} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="بحث بالاسم أو اسم المستخدم أو الإيميل..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="w-full border border-gray-300 rounded-xl py-2.5 pr-9 pl-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            />
          </div>
          <button
            onClick={() => { setActiveTab(PERMISSION_GROUPS[0].id); setAccountPanelOpen(true); setShowForm(true); }}
            className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-colors flex-shrink-0 max-md:w-full"
          >
            <Plus size={17} />
            إضافة مستخدم
          </button>
        </div>

        {/* ── قائمة المستخدمين ─────────────────────────────────────────────── */}
        <div className="mt-5 space-y-3">
          {filteredUsers.length === 0 ? (
            <div className="text-center py-16 text-gray-400">
              <Users size={40} className="mx-auto mb-3 opacity-30" />
              <p className="text-sm">{search ? 'لا توجد نتائج للبحث' : 'لا يوجد مستخدمين مضافين حالياً'}</p>
            </div>
          ) : (
            filteredUsers.map(user => (
              <UserCard
                key={user.UserId}
                user={user}
                onEdit={handleEdit}
                onDeactivate={handleDeactivate}
                onActivate={handleActivate}
                permCount={getPermissionCount(user.Permissions)}
              />
            ))
          )}
        </div>
      </div>

      {/* ── المودال ────────────────────────────────────────────────────────── */}
      {showForm && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-0 md:p-4 max-md:items-stretch">
          <div className="bg-white rounded-2xl w-full max-w-5xl max-h-[92vh] flex flex-col shadow-2xl max-md:rounded-none max-md:max-h-none max-md:h-[100dvh] max-md:max-w-none max-md:overflow-hidden">

            {/* رأس المودال */}
            <div className="flex items-center justify-between px-4 md:px-6 py-2.5 md:py-4 border-b border-gray-100 flex-shrink-0">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-9 h-9 max-md:w-8 max-md:h-8 rounded-xl bg-blue-600 flex-shrink-0 flex items-center justify-center">
                  <Shield size={17} className="text-white" />
                </div>
                <h2 className="text-base md:text-lg font-bold text-gray-900">
                  {editingId ? 'تعديل بيانات مستخدم' : 'إضافة مستخدم جديد'}
                </h2>
              </div>
              <button onClick={resetForm} className="p-2 hover:bg-gray-100 rounded-xl text-gray-400 transition-colors">
                <X size={20} />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0 max-md:overflow-hidden">

              {/* ── بيانات الحساب ─────────────────────────────────────────── */}
              <div className="px-4 md:px-6 py-2.5 md:py-4 border-b border-gray-100 bg-gray-50 flex-shrink-0 max-md:max-h-[42dvh] max-md:overflow-y-auto">
                <button
                  type="button"
                  onClick={() => setAccountPanelOpen(v => !v)}
                  className="w-full flex items-center justify-between gap-3 text-right md:cursor-default"
                >
                  <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">بيانات الحساب</p>
                    <p className="hidden max-md:block text-[11px] text-gray-400 mt-1">
                      املأ البيانات ثم اقفل هذا الجزء لرؤية الصلاحيات بالكامل
                    </p>
                  </div>
                  <span className="hidden max-md:inline-flex items-center gap-1 text-xs font-bold text-blue-700 bg-blue-50 px-3 py-1.5 rounded-full">
                    {accountPanelOpen ? 'إخفاء' : 'إظهار'}
                    <ChevronDown size={14} className={`transition-transform ${accountPanelOpen ? '' : 'rotate-180'}`} />
                  </span>
                </button>

                <div className={`${accountPanelOpen ? 'grid' : 'hidden md:grid'} grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-4 mt-3`}>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5">
                      اسم المستخدم <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.username}
                      onChange={e => setFormData({ ...formData, username: e.target.value })}
                      className="w-full border border-gray-300 rounded-xl p-2.5 max-md:p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5">
                      كلمة المرور
                      {editingId
                        ? <span className="text-gray-400 font-normal mr-1">(اتركها فارغة إذا لم ترد التغيير)</span>
                        : <span className="text-red-500"> *</span>
                      }
                    </label>
                    <input
                      type="password"
                      value={formData.password}
                      onChange={e => setFormData({ ...formData, password: e.target.value })}
                      className="w-full border border-gray-300 rounded-xl p-2.5 max-md:p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                      required={!editingId}
                    />
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5">
                      الاسم الكامل <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.fullName}
                      onChange={e => setFormData({ ...formData, fullName: e.target.value })}
                      className="w-full border border-gray-300 rounded-xl p-2.5 max-md:p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5">
                      البريد الإلكتروني <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={e => setFormData({ ...formData, email: e.target.value })}
                      className="w-full border border-gray-300 rounded-xl p-2.5 max-md:p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* ── الصلاحيات — تابات + محتوى ────────────────────────────── */}
              <div className="flex flex-col md:flex-row flex-1 min-h-0">

                {/* شريط التابات */}
                <div className="md:w-44 border-gray-100 bg-gray-50 flex md:flex-col py-2 md:py-3 px-2 gap-2 md:gap-1 flex-shrink-0 overflow-x-hidden md:overflow-x-visible md:overflow-y-auto max-md:border-b md:border-l max-md:grid max-md:grid-cols-3 max-md:overflow-visible">
                  <p className="hidden md:block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1 px-2">الصلاحيات</p>
                  {PERMISSION_GROUPS.map(group => {
                    const c = GROUP_COLORS[group.color];
                    const count = getGroupSelectedCount(group);
                    const isActive = activeTab === group.id;
                    return (
                      <button
                        key={group.id}
                        type="button"
                        onClick={() => setActiveTab(group.id)}
                        className={`flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium transition-all text-right md:w-full max-md:min-w-0 max-md:justify-center max-md:flex-col max-md:gap-1 max-md:px-1.5 max-md:py-2 max-md:text-xs max-md:leading-tight ${isActive ? c.tab : c.tabOff}`}
                      >
                        <span className="text-base leading-none">{group.icon}</span>
                        <span className="flex-1 max-md:flex-none max-md:truncate">{group.label}</span>
                        {count > 0 && (
                          <span className={`text-xs px-1.5 py-0.5 rounded-full font-bold ${isActive ? c.activeBadge : c.badge}`}>
                            {count}
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>

                {/* محتوى التاب */}
                <div className="flex-1 overflow-y-auto overflow-x-hidden p-3 md:p-5 pb-44 md:pb-5 max-md:min-h-0">
                  {PERMISSION_GROUPS.filter(g => g.id === activeTab).map(group => (
                    <div key={group.id}>
                      <p className="text-xs md:text-sm text-gray-500 mb-3 md:mb-4">
                        {group.icon} صلاحيات <span className="font-semibold text-gray-700">{group.label}</span> — اختر الصلاحيات المناسبة لهذا المستخدم
                      </p>
                      {group.sections.map(section => (
                        <PermissionSection
                          key={section.key}
                          sectionKey={section.key}
                          label={section.label}
                          items={section.items}
                          permissions={formData.permissions}
                          color={group.color}
                          onChange={handlePermissionChange}
                          onSelectAll={handleSectionSelectAll}
                        />
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              {/* ── أزرار الحفظ ───────────────────────────────────────────── */}
              <div className="flex flex-col-reverse md:flex-row md:justify-end gap-2 md:gap-3 px-4 md:px-6 py-2.5 md:py-4 border-t border-gray-100 bg-white flex-shrink-0 max-md:sticky max-md:bottom-0 max-md:shadow-[0_-8px_24px_rgba(15,23,42,0.08)] max-md:z-20">
                <button
                  type="button"
                  onClick={resetForm}
                  className="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors max-md:w-full"
                >
                  إلغاء
                </button>
                <button
                  type="submit"
                  className="flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-colors max-md:w-full"
                >
                  <Save size={16} />
                  {editingId ? 'حفظ التعديلات' : 'إضافة المستخدم'}
                </button>
              </div>

            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;